import { render, staticRenderFns } from "./EditTextModal.vue?vue&type=template&id=720fe34b&lang=pug"
import script from "./EditTextModal.vue?vue&type=script&lang=ts"
export * from "./EditTextModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports